import { config } from '@src/tracker/create-tracker';

export const DOWNLOAD_QR_POSITION = {
  HOME: '首页',
  HOME_SIDE: '首页侧边',
  INNER_SIDE: '内页侧边'
};

function getTrackUrl(targetUrl, sendParams) {
  const trackPageUrl = 'https://xfe.seasungame.com/m/2021/07/22/qr-track/index.html';
  const trackData = {
    stReport: {
      constructorParams: {
        ...config,
        projectIdentifier: config.identify
      },
      sendParams
    }
  };
  const params = ['track-data=' + encodeURIComponent(JSON.stringify(trackData)), 'redirect-url=' + encodeURIComponent(targetUrl)];
  return trackPageUrl + '?' + params.join('&');
}

function getIframeUrl(trackUrl) {
  const requestQueryString = encodeURIComponent(
    JSON.stringify({
      value: trackUrl,
      short: true
    })
  );
  return '//zhcdn01.xoyo.com/xassets/iframe/qr/0.0.x/index.html?' + requestQueryString;
}

function getDownloadQrIframeUrl(targetUrl, title) {
  const normalizedTargetUrl = typeof targetUrl === 'string' ? targetUrl.trim() : '';
  if (!normalizedTargetUrl) return '';

  const trackUrl = getTrackUrl(normalizedTargetUrl, {
    eventName: 'scan_download_game',
    eventDescription: '扫码下载',
    eventDataValue: { title }
  });
  return getIframeUrl(trackUrl);
}

export { getTrackUrl, getIframeUrl, getDownloadQrIframeUrl };
